/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheExportGapDto } from './FcbRechercheExportGapDto';
import {
    FcbRechercheExportGapDtoFromJSON,
    FcbRechercheExportGapDtoFromJSONTyped,
    FcbRechercheExportGapDtoToJSON,
} from './FcbRechercheExportGapDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheExportGapDtoPaginatedResults
 */
export interface FcbRechercheExportGapDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheExportGapDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheExportGapDto>}
     * @memberof FcbRechercheExportGapDtoPaginatedResults
     */
    results?: Array<FcbRechercheExportGapDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheExportGapDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheExportGapDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheExportGapDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheExportGapDtoPaginatedResultsFromJSON(json: any): FcbRechercheExportGapDtoPaginatedResults {
    return FcbRechercheExportGapDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheExportGapDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheExportGapDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheExportGapDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheExportGapDtoPaginatedResultsToJSON(value?: FcbRechercheExportGapDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheExportGapDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

